// import {$,jQuery} from 'jquery';
import inView from 'in-view';
// import 'jquery-touchswipe';
var imagesLoaded = require('imagesloaded');
// imagesLoaded.makeJQueryPlugin( $ );
// import TinyGesture from 'tinygesture';
import './swiped-events.min.js'

//* slider =================================================== */

var sliders = {};

class Slider {

  constructor(options) {

    // options
    this.id = options.id;
    this.sliderEl = document.querySelector('[data-sliderId="' + this.id + '"]');
    this.current = options.current;
    this.next = this.getNext();
    this.prev = this.getPrev();
    this.total = options.total;
    this.speed = options.speed;
    this.goFunc = false;
    this.waiting = false;
    this.screenWidth = window.innerWidth;
    this.screenWidthHalf = this.ScreenWidth / 2;
    this.offset = false;
    this.moving = false;
    this.type = 'zoom';
    this.show = 1;

    // init
    var sliderEl = this.sliderEl;

    // count slides
    this.total = sliderEl.querySelectorAll('.slider-slide').length;

    // set slide ids
    var slideId = 0;
    var hasTitles = false;
    var hasSubtitles = false;
    sliderEl.querySelectorAll('.slider-slide').forEach(slide => {

      // set slide id
      slideId ++;
      slide.setAttribute('data-id', slideId);

      // check title and subtitles
      if (slide.getAttribute('data-title').length) {
        hasTitles = true;
      }
      if (slide.getAttribute('data-subtitle').length) {
        hasSubtitles = true;
      }

    });

    // remove titles if not needed
    if (!hasTitles) {
      sliderEl.querySelector('.slider-title').remove();
    }
    if (!hasSubtitles) {
      sliderEl.querySelector('.slider-subtitle').remove();
    }

    // resize slides
    this.resize();

    // create offsets
    var sliderElOffsetRight = sliderEl.querySelector('.slider-track-main').cloneNode(true);
    sliderElOffsetRight.classList.add('slider-offset-right');
    sliderElOffsetRight.classList.remove('slider-track-main');
    sliderElOffsetRight.style.left = '100%';
    sliderEl.querySelector('.slider-tracks').appendChild(sliderElOffsetRight);

    var sliderElOffsetLeft = sliderEl.querySelector('.slider-track-main').cloneNode(true);
    sliderElOffsetLeft.classList.add('slider-offset-left');
    sliderElOffsetLeft.classList.remove('slider-track-main');
    sliderElOffsetLeft.style.left = '-100%';
    sliderEl.querySelector('.slider-tracks').appendChild(sliderElOffsetLeft);

    // create nav
    for (var i=1;i<=this.total;i++) {
      const newBtn = document.createElement('button');
      newBtn.classList.add('slider-dot');
      newBtn.setAttribute('data-id', i);
      newBtn.setAttribute('data-sliderId', this.id);
      sliderEl.querySelector('.slider-nav').appendChild(newBtn);
    }

    // start
    sliderEl.classList.add('s_init');
    this.start();

    sliderEl.querySelectorAll('.slider-dot').forEach(el => {
      el.addEventListener('click', (event) => {
        var sliderId = el.getAttribute('data-sliderId');
        var slideId = el.getAttribute('data-id');
        sliders[sliderId].restartTimer();
        sliders[sliderId].setSlide(slideId);
        return false;
      });
    });
  }

  resize() {

    this.clipWings();

    var sliderEl = this.sliderEl;

    // reset screen variables
    this.screenWidth = window.innerWidth;
    this.screenWidthHalf = this.screenWidth / 2;

    // resize images responsively
    var imageWidth = false;
    var imageHeight = false;
    if (window.innerWidth > 1279) {
      imageHeight = 600;
    } else if (window.innerWidth > 768) {
      imageHeight = 514;
    } else if (window.innerWidth > 600) {
      imageHeight = 300;
    // } else if (breakpointMin('baby')) {
      // imageWidth = $('.row-inner').width() - 60;
    } else {
      imageHeight = 200;
      // imageWidth = $(window).width();
    }

    // apply image resizing
    var images = sliderEl.querySelectorAll('.slider-image')
    var imageWidthVal = 'auto';
    var imageHeightVal = 'auto';
    if (imageWidth && imageHeight) {
      imageWidthVal = imageWidth + 'px';
      imageHeightVal = imageHeight + 'px';
    } else if (imageHeight) {
      imageWidthVal = 'auto';
      imageHeightVal = imageHeight + 'px';
    } else if (imageWidth) {
      imageWidthVal = imageWidth + 'px';
      imageHeightVal = 'auto';
    }
    images.forEach(image => {
      image.style.height = imageHeightVal;
      image.style.width = imageWidthVal;
      image.querySelectorAll('img').forEach(img => {
        img.style.height = imageHeightVal;
        img.style.width = imageWidthVal;
      })
    })

    var slidesAllWidth = 0;
    sliderEl.querySelectorAll('.slider-track-main .slider-slide').forEach((slide) => {
      var style = slide.currentStyle || window.getComputedStyle(slide);
      slidesAllWidth += slide.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight);
    });
    sliderEl.querySelectorAll('.slider-track, .slider-tracks').forEach(el => {
      el.style.width = slidesAllWidth + 'px';
    });
    if (sliderEl.querySelector('.slider-offset-right')) sliderEl.querySelector('.slider-offset-right').style.left = '100%';
    if (sliderEl.querySelector('.slider-offset-left')) sliderEl.querySelector('.slider-offset-left').style.left = '-100%';

  }

  start() {
    // var sliderId = this.id;
    // this.goFunc = setInterval(() => {
    // }, this.speed);
    this.updateSlide();
  }

  restartTimer() {
    // var sliderId = this.id;
    // clearInterval(this.goFunc);
    // this.goFunc = setInterval(() => {
    // }, this.speed);
  }

  nextSlide() {
    if (!this.waiting) {
      this.current = this.getNextSlideId();
      if (this.current == 1) {
        this.offset = 'right';
      }
      this.updateSlide();
    }
  }

  prevSlide() {
    if (!this.waiting) {
      this.current = this.getPrevSlideId();
      if (this.current == this.total) {
        this.offset = 'left';
      }
      this.updateSlide();
    }
  }

  getNextSlideId() {
    var slideId = this.current + 1;
    if (slideId > this.total) {
      slideId = 1;
    }
    return slideId;
  }

  getPrevSlideId() {
    var slideId = this.current - 1;
    if (slideId < 1) {
      slideId = this.total;
    }
    return slideId;
  }

  setSlide(slideId) {

    var nextId = this.getNextSlideId();
    var prevId = this.getPrevSlideId();

    if (slideId == nextId) {
      this.nextSlide();
    } else if (slideId == prevId) {
      this.prevSlide();
    } else {
      if (!this.waiting) {
        this.current = slideId;
        this.updateSlide();
      }
    }
  }

  clipWings() {

    // var sliderEl = this.sliderEl;

    // var maxPad = 50;
    // sliderEl.querySelector('.slider-track .slider-slide').each(function(){

    //   if (!$(this).hasClass('s_active')) {
    //     var tempWidth = $(this).querySelector('.slider-image').offsetWidth;
    //     var tempPad = maxPad - (tempWidth * .15  / 2);
    //     if (tempPad < 0) {
    //       tempPad = 0;
    //     }
    //     console.log('tempPad: ' + tempPad);
    //     $(this).css('padding-left', tempPad + 'px');
    //     $(this).css('padding-right', tempPad + 'px');
    //   } else {
    //     $(this).css('padding-left', maxPad + 'px');
    //     $(this).css('padding-right', maxPad + 'px');
    //   }

    // });

  }

  updateSlide() {

    var sliderId = this.id;
    var sliderEl = this.sliderEl;
    var slideEl = sliderEl.querySelector('.slider-slide[data-id="' + this.current + '"]');

    this.waiting = true;

    var slideActive = sliderEl.querySelector('.slider-slide.s_active')
    if (slideActive) {
      slideActive.classList.remove('s_active');
      slideActive.classList.remove('s_usable');
    }
    slideEl.classList.add('s_active');

    this.clipWings();

    // this.resize();

    // update titles
    var slideTitle = slideEl.getAttribute('data-title');
    if (slideTitle.length == 0) {
      slideTitle = '&nbsp;';
    }
    if (sliderEl.querySelector('.slider-title')) {
      sliderEl.querySelector('.slider-title').classList.remove('s_active');
      sliderEl.querySelector('.slider-title').html(slideTitle);
      setTimeout(() => {
        sliderEl.querySelector('.slider-title').classList.add('s_active');
      }, 300);
    }

    var slideSubtitle = slideEl.getAttribute('data-subtitle');
    if (slideSubtitle.length == 0) {
      slideSubtitle = '&nbsp;';
    }
    if (sliderEl.querySelector('.slider-subtitle')) {
      sliderEl.querySelector('.slider-subtitle').classList.remove('s_active');
      sliderEl.querySelector('.slider-subtitle').html(slideSubtitle);
      setTimeout(() => {
        sliderEl.querySelector('.slider-subtitle').classList.add('s_active');
      }, 300);
    }

    // next + prev
    this.updateNextPrev();
    if (sliderEl.querySelector('.slider-slide.s_next')) sliderEl.querySelector('.slider-slide.s_next').classList.remove('s_next');
    if (sliderEl.querySelector('.slider-slide.s_prev')) sliderEl.querySelector('.slider-slide.s_prev').classList.remove('s_prev');
    if (sliderEl.querySelector('.slider-slide[data-id="' + this.next + '"]')) sliderEl.querySelector('.slider-slide[data-id="' + this.next + '"]').classList.add('s_next');
    if (sliderEl.querySelector('.slider-slide[data-id="' + this.prev + '"]')) sliderEl.querySelector('.slider-slide[data-id="' + this.prev + '"]').classList.add('s_prev');

    // update height of slider
    this.outerHeight = slideEl.offsetHeight;
    sliderEl.querySelector('.slider-container').style.height = this.outerHeight + 'px';
    sliderEl.querySelector('.slider-invisinav').style.height = this.outerHeight + 'px';

    // if offset, set extra value
    var sliderPositionExtra = 0;
    if (this.offset == 'right') {
      sliderPositionExtra = sliderEl.querySelector('.slider-track-main').offsetWidth;
    } else if (this.offset == 'left') {
      sliderPositionExtra = sliderEl.querySelector('.slider-track-main').offsetWidth * -1;
    }

    // calculate offset
    var sliderPosition = ( ( slideEl.offsetLeft + ( slideEl.offsetWidth / 2 ) ) - this.screenWidthHalf + sliderPositionExtra ) * -1;

    // move slider
    var tracks = sliderEl.querySelector('.slider-tracks');
    tracks.classList.add('s_animate');
    tracks.style.left = sliderPosition + 'px';
    tracks.addEventListener('transitionend', () => {

      tracks.classList.remove('s_animate');

      if (this.offset == 'right' || this.offset == 'left') {
        var offsetReset = sliderPosition + sliderPositionExtra;
        sliderEl.querySelector('.slider-tracks').style.left = offsetReset + 'px';
        this.offset = false;
      }

      var activeSlideEdge = slideEl.offsetWidth + ((this.screenWidth - slideEl.offsetWidth) / 2);
      sliderEl.querySelector('.slider-invisibtn.l_next').style.left = activeSlideEdge + 'px';
      sliderEl.querySelector('.slider-invisibtn.l_prev').style.right = activeSlideEdge + 'px';
      setTimeout(() => {
        sliderEl.querySelector('.slider-slide.s_active').classList.add('s_usable');
      }, 150);

      this.waiting = false;

    });



    // update dots
    sliderEl.querySelectorAll('.slider-dot').forEach(dot => {
      dot.classList.remove('s_active');
    });
    sliderEl.querySelector('.slider-dot[data-id="' + this.current + '"]').classList.add('s_active');

  }

  getNext() {
    this.next = this.current + 1;
    if (this.next > this.total) { this.next = 1; }
  }

  getPrev() {
    this.prev = this.current - 1;
    if (this.prev < 1) { this.prev = this.total; }
  }

  updateNextPrev() {
    this.getNext();
    this.getPrev();
  }

  // activateSlide() {
  //   var sliderEl = $('[data-sliderId="' + this.id + '"]');
  //   sliderEl.querySelector('.slider-slide.s_next').classList.add('s_active').classList.remove('s_next');
  //   $('.slider-slidecomp.s_next').classList.add('s_active').classList.remove('s_next');
  // }

  // hideSlide() {
  //   var sliderEl = $('[data-sliderId="' + this.id + '"]');
  //   sliderEl.querySelector('.slider-slide.s_hide').classList.remove('s_hide s_transitions s_active').css('z-index', 0);
  //   $('.slider-slidecomp.s_hide').classList.remove('s_hide s_transitions s_active').css('z-index', 0);
  //   this.waiting = false;
  // }
}


var sliderNum = 0;
function sliderInit(el) {

  // $el.forEach((el) => {

    imagesLoaded(el, (instance) => {


      if (el.querySelectorAll('.slider-slide').length > 1) {

        sliderNum++;

        var sliderId = 'slider' + sliderNum;

        el.setAttribute('data-sliderId', sliderId);
        var options = {
          id: sliderId,
          current: 2,
          total: el.querySelectorAll('.slider-slide').length,
          speed: 4000
        };
        setTimeout(() => {
          sliders[sliderId] = new Slider(options);
        }, 50);
        setTimeout(() => {
          sliders[sliderId].resize();
        }, 100);
      } else {
        el.querySelectorAll('.slider-slide').forEach(slide => {
          slide.classList.add('s_active');
        });
        // $('.slider-slidecomp').classList.add('s_active');
        el.querySelector('.slider-controls').remove();
      }

    });

  // });

};

inView('.slider').on('enter', el => {

  if (!el.getAttribute('data-init')) {

    el.querySelectorAll('.slider-image').forEach((image) => {

      if (image.getAttribute('data-src')) {
        image.setAttribute('src', image.getAttribute('data-src'));
      }

    });

    // setTimeout(() => {
    sliderInit(el);
    // }, 1000);

  }

  el.setAttribute('data-init', true);

});

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-action="nextSlide"]').forEach(el => {
    el.addEventListener('click', (event) => {
      var sliderId = el.closest('.slider').getAttribute('data-sliderId');
      sliders[sliderId].restartTimer();
      sliders[sliderId].nextSlide();
      return false;
    });
  });

  document.querySelectorAll('[data-action="prevSlide"]').forEach(el => {
    el.addEventListener('click', (event) => {
      var sliderId = el.closest('.slider').getAttribute('data-sliderId');
      sliders[sliderId].restartTimer();
      sliders[sliderId].prevSlide();
      return false;
    });
  });

  // document.querySelectorAll('.slider-dot').forEach(el => {
  //   el.addEventListener('click', (event) => {
  //     console.log('dot click');
  //     var sliderId = el.getAttribute('data-sliderId');
  //     var slideId = el.getAttribute('data-id');
  //     sliders[sliderId].restartTimer();
  //     sliders[sliderId].setSlide(slideId);
  //     return false;
  //   });
  // });

  // document.querySelectorAll('.slider-arrow').forEach(el => {
  //   document.addEventListener('mousemove', (event) => {
  //     const arrowX = event.clientX;
  //     const arrowY = event.clientY;
  //     el.style.top = `${arrowY}px`;
  //     el.style.left = `${arrowX}px`;
  //     if (event.target.classList.contains('slider-invisibtn')) {
  //       el.classList.add('s_active');
  //       if (event.target.classList.contains('l_next')) {
  //         el.classList.add('l_next');
  //         el.classList.remove('l_prev');
  //       } else if (event.target.classList.contains('l_prev')) {
  //         el.classList.add('l_prev');
  //         el.classList.remove('l_next');
  //       }
  //     } else {
  //       el.classList.remove('s_active');
  //     }
  //   });
  // });

});

let windowWidth = window.innerWidth;
window.addEventListener('resize', (event) => {

  if (windowWidth !== window.innerWidth) {
    windowWidth = window.innerWidth;

    const keys = Object.keys(sliders)
    for (const key of keys) {
      setTimeout(() => {
        sliders[key].resize();
        sliders[key].updateSlide();
      }, 100);
    }

  }

});

document.addEventListener('keydown', (event) => {

  if (typeof sliders !== 'undefined' && sliders.length) {

    // left
    if (e.keyCode == 37) {
      sliders['slider1'].restartTimer();
      sliders['slider1'].prevSlide();
    }

    // right
    if (e.keyCode == 39) {
      sliders['slider1'].restartTimer();
      sliders['slider1'].nextSlide();
    }

  }

});

document.addEventListener('swiped-right', function(e) {
  let sliderId = 'slider1';
  let slider = e.target.closest('.slider');
  if (slider) sliderId = slider.getAttribute('data-sliderId');
  sliders[sliderId].restartTimer();
  sliders[sliderId].prevSlide();
  return false;
});

document.addEventListener('swiped-left', function(e) {
  let sliderId = 'slider1';
  let slider = e.target.closest('.slider');
  if (slider) sliderId = slider.getAttribute('data-sliderId');
  sliders[sliderId].restartTimer();
  sliders[sliderId].nextSlide();
  return false;
});
